/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Paste_JsonInputs */

const en_tree_paste_json = /** @type {(inputs: Tree_Paste_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste JSON to see tree view`)
};

const ko_tree_paste_json = /** @type {(inputs: Tree_Paste_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 붙여넣으면 트리 뷰가 표시됩니다`)
};

const ja_tree_paste_json = /** @type {(inputs: Tree_Paste_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONを貼り付けるとツリービューが表示されます`)
};

/**
* | output |
* | --- |
* | "Paste JSON to see tree view" |
*
* @param {Tree_Paste_JsonInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const tree_paste_json = /** @type {((inputs?: Tree_Paste_JsonInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Paste_JsonInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_paste_json(inputs)
	if (locale === "ko") return ko_tree_paste_json(inputs)
	return ja_tree_paste_json(inputs)
});